import React, { PureComponent } from 'react';
import StaticPageLayout from 'src/components/StaticPageLayout';
import pageTracker from 'src/lib/hoc/pageTracker';
import withDictionary from 'src/lib/hoc/withDictionary';
import withWhoAmI from 'src/lib/hoc/withWhoAmI';
import styles from './styles.module.scss';

export async function getServerSideProps(context) {
	const { req } = context;
	const host = req.headers.host;
	return {
		props: { host }, // will be passed to the page component as props
	};
}

@pageTracker()
@withWhoAmI()
@withDictionary()
class About extends PureComponent {
	render = () => {
		const { whoami, dictionary } = this.props;
		const { FULL_DOMAIN } = whoami;

		return (
			<StaticPageLayout pageTitle={dictionary("About Us")}>
				<div
					className={styles.under_search_text}
					dangerouslySetInnerHTML={{ __html: dictionary({ type: 'about' }).replace(/@@FULL_DOMAIN@@/g, FULL_DOMAIN) }}></div>
			</StaticPageLayout>
		);
	};
}

About.propTypes = {};

export default About;
